function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormGroup, FormHelperText, FormLabel, Tooltip } from '@material-ui/core';
import { Checkbox } from '../Checkbox';
import { OptionGroup, withGroupedOptionHelpers, withStandardOptionHelpers } from '../../lib/optionHelpers';
import useFormHelpers from '../../hooks/useFormHelpers';

let CheckboxGroup = ({
  error,
  getOptionHelperText,
  getOptionKey,
  getOptionLabel,
  getOptionType,
  getOptionValue,
  helperText,
  label,
  onChange,
  options,
  row,
  showCheckAll,
  value: checkedOptions = [],
  ...props
}) => {
  const allOptionsChecked = checkedOptions.length === options.length;

  const optionIsChecked = option => checkedOptions.includes(getOptionValue(option));

  return React.createElement(FormControl, _extends({
    error: error,
    component: "fieldset",
    margin: "normal"
  }, props), React.createElement(FormLabel, null, showCheckAll ? React.createElement(Tooltip, {
    title: allOptionsChecked ? 'Uncheck All' : 'Check All'
  }, React.createElement(Checkbox, {
    label: label,
    value: allOptionsChecked,
    onChange: value => {
      if (value) {
        onChange(options.map(getOptionValue));
      } else {
        onChange([]);
      }
    }
  })) : label), React.createElement(FormGroup, {
    row: row
  }, options.map(option => getOptionType(option) === 'group' ? React.createElement(OptionGroup, {
    key: getOptionKey(option),
    style: {
      padding: 0
    },
    component: "label"
  }, getOptionLabel(option)) : React.createElement(Checkbox, {
    key: getOptionKey(option),
    label: getOptionLabel(option),
    value: optionIsChecked(option),
    onChange: checked => {
      let newValues;
      const clickedOption = option;

      if (checked) {
        newValues = options.filter(option => optionIsChecked(option) || option === clickedOption).map(getOptionValue);
      } else {
        newValues = checkedOptions.filter(value => value !== getOptionValue(option));
      }

      onChange(newValues);
    },
    helperText: getOptionHelperText(option)
  }))), helperText && React.createElement(FormHelperText, {
    error: error
  }, helperText));
};

CheckboxGroup.propTypes = {
  error: PropTypes.bool,
  getOptionHelperText: PropTypes.func,
  helperText: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  row: PropTypes.bool,
  showCheckAll: PropTypes.bool,
  value: PropTypes.array
};
CheckboxGroup.defaultProps = {
  getOptionHelperText: () => undefined
};
CheckboxGroup = withGroupedOptionHelpers(withStandardOptionHelpers(CheckboxGroup));

const LinkedCheckboxGroup = props => {
  const helpers = useFormHelpers(props);
  return React.createElement(CheckboxGroup, helpers);
};

export { CheckboxGroup, LinkedCheckboxGroup };